const B_1 = [
    {
        title: '导出标书款收入',
        path: '/manage/finance/exportbsk/list',
    }
]

export default {
    path: 'exportbsk',
    component: () => import(/*webpackChunkName: 'finance-exportorder'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import(/*webpackChunkName: 'finance-exportorder'*/ '@views/manage/views/finance/export-order/list'),
            meta: {
                title: '核实标书款',
                topNav: true,
                bread: B_1
            },
        }, 
    ]
}
